/**
 * moduleにstore定義を作る際のサンプルです。
 * ※../storeAccessorには定義していません。
 */
export default {
    // namespacedをtrueにすることで、他のStoreとの衝突を避ける事が可能です。
    // storeアクセス時にsample/methodという形でのアクセスにできる。
	namespaced: true,
	state: {
		/** フラグ */
		sampleFlag: false
	},
	mutations: {
		/**
		 * サンプルフラグを設定します。
		 * @param {*} state 管理データ
		 * @param {*} sampleFlag サンプルフラグ
		 */
		setSampleFlag: (state, sampleFlag) => {
			state.sampleFlag = sampleFlag;
		}
	},
	getters: {
		/**
		 * サンプルフラグを取得します。
		 * @param {*} state 管理データ
		 * @return サンプルフラグ
		 */
		getSampleFlag: state => {
			return state.sampleFlag;
		}
	}
};
